/**
 * Closes the user's HyperComply session, then signs them out of the app. Getting out matters
 * more than closing the HyperComply session cleanly, so a refusal still signs the user out and
 * still clears the HyperComply sign-in state, which would otherwise carry into the next session.
 * @param {{
 *   hyperComplySignout: (body: { email?: string }, callbacks: { onSuccess: () => void, onError: () => void }) => void,
 *   signOut: () => void,
 *   email?: string,
 * }} options
 */
export function signOutOfHyperComplyThenApp({ hyperComplySignout, signOut, email }) {
  const leave = () => {
    localStorage.setItem("reloadIframe", "true");
    sessionStorage.removeItem("sso_state");
    signOut();
  };
  hyperComplySignout({ email }, { onSuccess: leave, onError: leave });
}
